import { retrieveObjectMapper } from '../..';

export const transformMarketingConsent = (data = {}) => ({
  ...retrieveObjectMapper(data, [
    'ID:id',
    'fk_marketing_consent_user',
    'fk_user',
    'document_url',
    'document_url_presigned_url',
  ]),
});

export const transformMCBusinessEntities = (data = []) =>
  data.map(item => ({
    ...retrieveObjectMapper(item, [
      'ID:id',
      'phone',
      'sms',
      'email',
      'whatsapp',
    ]),
  }));

export const transformLeadsByChild = ({
  leads = [],
  centres = [],
  levels = [],
  programs = [],
  codes = [],
  leadTags = {},
  lastUpdatedByUsers = {},
  registrations = {},
}) =>
  leads?.map(item => {
    const allTags = leadTags?.[item?.id];
    const lastUpdatedBy = lastUpdatedByUsers?.[item?.id];
    const registration = registrations?.[item?.id];
    const currentCentre = centres?.find(({ id }) => id === item?.fk_centre);
    const currentLevel = levels?.find(({ id }) => id === item?.fk_level);
    const currentProgram = programs?.find(({ id }) => id === item?.fk_program);
    const currentCodes = codes?.find(({ id }) => id === item?.fk_cancel_code);

    return {
      ...retrieveObjectMapper(item, [
        'ID:id',
        'centre_preference',
        'current_lead_frontend_status',
        'enrolment_date',
        'first_enquire_date',
        'expire_at',
        'weightage',
        'type:type_string',
        'updated_at',
        'created_at',
        'remarks',
      ]),
      centre: currentCentre && {
        ...retrieveObjectMapper(currentCentre, ['ID:id', 'label']),
      },
      level: currentLevel && {
        ...retrieveObjectMapper(currentLevel, ['ID:id', 'label']),
      },
      program: currentProgram && {
        ...retrieveObjectMapper(currentProgram, ['ID:id', 'label']),
      },
      code: currentCodes && {
        ...retrieveObjectMapper(currentCodes, [
          'ID:id',
          'label',
          'description',
        ]),
      },
      LastUpdatedBy: lastUpdatedBy && {
        ...retrieveObjectMapper(lastUpdatedBy, [
          'ID:user_id',
          'firstname:first_name',
          'lastname:last_name',
        ]),
      },
      registrations: {
        data:
          registration?.data?.map(reg => ({
            ...retrieveObjectMapper(reg?.Registration, ['ID:id', 'fk_user']),
            registrationChildMappings: {
              data:
                reg?.RegistrationChildMapping?.data?.map(childMapping => ({
                  ...retrieveObjectMapper(childMapping, [
                    'ID:id',
                    'fk_registration_child',
                  ]),
                })) || [],
            },
          })) || [],
      },
      AllTagOfLeads: {
        data:
          allTags?.data?.map(item => ({
            ...retrieveObjectMapper(item, [
              'ID:id',
              'label',
              'weight',
              'description',
              'created_at',
              'active',
            ]),
          })) || [],
      },
    };
  });

export const transformLeadActivityLogs = ({
  data = [],
  staffs = {},
  codeByFkChannels = [],
  codeByFkLeadSources = [],
  codeByFkMediums = [],
  centreByFkCentres = [],
}) =>
  data?.map(dt => ({
    ...dt,
    staff: staffs?.[dt?.fk_staff],
    codeByFkChannel: codeByFkChannels?.find(({ id }) => id === dt?.fk_channel),
    codeByFkLeadSource: codeByFkLeadSources?.find(
      ({ id }) => id === dt?.fk_lead_source
    ),
    codeByFkMedium: codeByFkMediums?.find(({ id }) => id === dt?.fk_medium),
    centre: centreByFkCentres?.find(({ id }) => id === dt?.fk_centre),
  }));

export const transformLeadById = ({
  data = {},
  leads = {},
  codeByFkParentRelationship = {},
  codeByFkFirstChannel = {},
  codeByFkFirstLeadSource = {},
  codeByFkFirstMedium = {},
  leadActivityLogs = [],
  lastUpdatedBy = {},
}) => {
  const leadChild = data?.lead_child || {};
  return {
    ...retrieveObjectMapper(data, [
      'ID:id',
      'fk_lead_child',
      'enrolment_date',
      'updated_at',
      'current_lead_frontend_status',
      'reference_number',
      'first_enquire_date',
      'centre_preference',
    ]),
    leadChild: {
      LastUpdatedBy:
        lastUpdatedBy?.[leadChild?.id] &&
        retrieveObjectMapper(lastUpdatedBy?.[leadChild?.id], [
          'firstname:first_name',
          'lastname:last_name',
        ]),
      ...retrieveObjectMapper(leadChild, [
        'ID:id',
        'is_unborn',
        'child_name',
        'child_date_of_birth',
        'child_origin_birth_certificate',
        'child_birth_certificate',
        'nationality',
        'gender',
        'race',
        'parent_identification_no',
        'fk_parent_relationship',
        'parent_name',
        'parent_email',
        'parent_mobile_phone',
        'parent_mobile_phone_country_code',
        'parent_workplace',
        'updated_at',
        'postal_code',
        'household_income',
        'address',
        'building',
        'unit',
        'floor',
        'block_no',
        'ad_content',
        'campaign',
        'referral_code',
        'notes',
        'marketing_consent',
      ]),
      codeByFkParentRelationship,
      codeByFkFirstChannel,
      codeByFkFirstLeadSource,
      codeByFkFirstMedium,
      leads,
      leadActivityLogs: {
        data: leadActivityLogs?.map(log => {
          const staffUser = log?.staff?.data?.[0];
          return {
            ...retrieveObjectMapper(log, [
              'ID:id',
              'campaign',
              'ad_content',
              'referral_code',
              'enquire_date',
              'parent_email',
              'parent_name',
              'correspondence',
              'time_of_correspondence',
              'subject',
              'parent_mobile_phone',
              'parent_mobile_phone_country_code',
            ]),
            staff: staffUser?.staff && {
              ...retrieveObjectMapper(staffUser?.staff, ['ID:id']),
              userByFkUser: staffUser?.user && {
                ...retrieveObjectMapper(staffUser?.user, [
                  'ID:id',
                  'firstname',
                  'lastname',
                ]),
              },
            },
            codeByFkChannel: log?.codeByFkChannel && {
              ...retrieveObjectMapper(log?.codeByFkChannel, [
                'ID:id',
                'description',
                'label',
              ]),
            },
            codeByFkLeadSource: log?.codeByFkLeadSource && {
              ...retrieveObjectMapper(log?.codeByFkLeadSource, [
                'ID:id',
                'description',
                'label',
              ]),
            },
            codeByFkMedium: log?.codeByFkMedium && {
              ...retrieveObjectMapper(log?.codeByFkMedium, [
                'ID:id',
                'description',
                'label',
              ]),
            },
            centre: log?.centre && {
              ...retrieveObjectMapper(log?.centre, ['ID:id', 'label', 'code']),
            },
          };
        }),
      },
    },
  };
};

export const transformGetAllLeads = (data = [], centres, levels, programs) =>
  data?.map(item => {
    const currentCentre = centres?.find(({ id }) => id === item?.fk_centre);
    const currentLevel = levels?.find(({ id }) => id === item?.fk_level);
    const currentProgram = programs?.find(({ id }) => id === item?.fk_program);

    return {
      ...retrieveObjectMapper(item, [
        'ID:id',
        'type:type_string',
        'status:status_string',
        'expireAt:expire_at',
        'firstEnquireDate:first_enquire_date',
        'centrePreference:centre_preference',
        'enrolmentDate:enrolment_date',
        'createdAt:created_at',
        'weightage:weightage',
        'CurrentLeadFrontendStatus:lead_frontend_status',
        'AnotherActiveLeadStatus:another_active_lead_status',
      ]),
      centre: currentCentre && {
        ...retrieveObjectMapper(currentCentre, ['ID:id', 'label']),
      },
      level: currentLevel && {
        ...retrieveObjectMapper(currentLevel, ['ID:id', 'label']),
      },
      program: currentProgram && {
        ...retrieveObjectMapper(currentProgram, ['ID:id', 'label']),
      },
      leadChild: {
        ...retrieveObjectMapper(item?.lead_child, [
          'child_birth_certificate',
          'parent_name',
          'parent_email',
          'parent_mobile_phone',
          'parent_mobile_phone_country_code',
          'child_name',
          'child_date_of_birth',
        ]),
      },
    };
  });

export default { transformLeadById, transformGetAllLeads };
